"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHexColorIcon = exports.StyledHexInput = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _attachThemeAttrs = _interopRequireDefault(require("../../../../styles/helpers/attachThemeAttrs"));

var _Input = _interopRequireDefault(require("../../../Input"));

var _styled = require("../styled");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    font: inherit;\n    line-height: 2.5rem;\n    font-size: 1rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    input {\n        ", "\n        padding: 0 0.7rem 0 1rem;\n\n        :focus,\n        :active {\n            padding: 0 0.65625rem 0 0.9375rem;\n        }\n    }\n\n    > div > span {\n        left: 0.2rem;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledHexInput = (0, _styledComponents["default"])(_Input["default"])(_templateObject(), _styled.CssInput);
exports.StyledHexInput = StyledHexInput;
var StyledHexColorIcon = (0, _attachThemeAttrs["default"])(_styledComponents["default"].span)(_templateObject2());
exports.StyledHexColorIcon = StyledHexColorIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/ColorPicker/commons/hex/styled.js
// module id = Qzs/
// module chunks = 0